import { assoc, pipe, prop, propOr, sortBy } from 'ramda'
import { round } from '@btime/helpers'
import moment from 'moment'
import { useReplies, useServiceOrder } from '../_load/ServiceOrderLoader'
import { countReplies } from '../../../../utils/helpers/repliesCounter'
import { formatLongRunningTime } from '../../../../utils/helpers/date'

// TODO: Remove after statusTime is being handled by the api

const buildStatusTime = events => {
  return events.reduce((statusTime, event, index) => {
    const nextEvent = events[index + 1]
    if (!nextEvent) return statusTime
    const statusName = event.status.name
    const time = diff(event, nextEvent)
    const currentTimeInStatus = statusTime[statusName] || 0
    return assoc(statusName, currentTimeInStatus + time, statusTime)
  }, {})
}

const diff = (current, next) => moment(next.eventDate).diff(current.eventDate)

export const calculateAttendanceTime = pipe(
  sortBy(prop('eventDate')), //
  buildStatusTime,
  propOr(0, 'execution'),
  formatLongRunningTime
  // time => moment().millisecond(time).format('HH MM SS')
)

export const useResumeCounters = tmpServiceOrder => {
  const serviceOrder = useServiceOrder() || tmpServiceOrder
  const replies = useReplies() || serviceOrder.replies
  const events = serviceOrder.events || []
  const counters = countReplies(replies)
  const { affirmativeCount, negativeCount } = counters

  const score = round((affirmativeCount / (affirmativeCount + negativeCount)) * 100)

  const attendanceTime = calculateAttendanceTime(events)
  return { ...counters, score, attendanceTime }
}
